// extracted by mini-css-extract-plugin
module.exports = {"Block":"styles_Block__1jWym","Block-title":"styles_Block-title__3abN3","Block-description":"styles_Block-description__3vFUd","Block-content":"styles_Block-content__1M6F4"};